import BreadCrumb from '@react/shared/components/BreadCrumb';
import Footer from '@react/shared/components/Footer';
import Header from '@react/shared/components/Header/Header.container';
import Separator from '@react/shared/components/Separator';
import Helmet from 'next/head';
import { StrictMode } from 'react';
import ProviderIndexBody from 'sly/providerIndex/ProviderIndexBody';
import ProviderIndexHeader from 'sly/providerIndex/providerIndexHeader';

export default function ProviderIndex() {
  return (
    <StrictMode>
      <Helmet>
        <title>Senior Living Companies and Providers | Seniorly</title>
        <meta
          name='description'
          content='Take a look at some of the largest senior living companies in the country. Seniorly can help you find out more about different senior living providers.'
        />
      </Helmet>
      <header className='relative'>
        <Header />
      </header>
      <div className='mx-auto px-4 md:w-[var(--col8)] md:py-xl lg:w-[var(--col12)] lg:py-xxl'>
        <BreadCrumb
          items={[
            { label: 'Home', path: '/' },
            { label: 'Providers', path: '/providers' },
          ]}
        />
        <ProviderIndexHeader />
        <Separator className='!my-4 md:my-8' />
        <ProviderIndexBody />
      </div>
      <Footer />
    </StrictMode>
  );
}

ProviderIndex.whyDidYouRender = true;
